module.exports = __webpack_public_path__ + "b2f0318b1c219a7c098a34201485bda9.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/image-1.jpg
// module id = ./assets/images/footer/image-1.jpg
// module chunks = 0